import { ActionType } from 'typesafe-actions';
import * as jobsActionCreators from './actions';
import reducer from './reducer';

export default reducer;

export const actions = jobsActionCreators;

export * from './types';
export type JobsActions = ActionType<typeof jobsActionCreators>;
